import * as React from 'react';
import { LinkHelper } from '../../routes';
const styles = require('./Search.less') as any;

const PERMISSION_DENIED = 1;
const POSITION_UNAVAILABLE = 2;
const TIMEOUT = 3;

const NoGPS = ({ code }) => (
		<div className={styles.LocationWarning}>
				{code === PERMISSION_DENIED ? (
						 <div>GPS Location denied: Position may be inaccurate
								 <LinkHelper to='/help/' style={{float: 'right', cursor: 'pointer'}}>Fix it</LinkHelper>
						 </div>
				 ) : (
						 <div>GPS Location unavailable: Position may be innaccurate
								 <LinkHelper to='/help/' style={{float: 'right', cursor: 'pointer'}}>Get help</LinkHelper>
						 </div>
				 )}
		</div>
);

export default NoGPS;



// WEBPACK FOOTER //
// ./src/app/containers/Search/NoGPS.tsx